var PartnerType = /*#__PURE__*/function (PartnerType) {
  PartnerType["InboundApi"] = "insulet";
  PartnerType["Redox"] = "redox";
  PartnerType["PartnerApi"] = "api";
  PartnerType["CommercialAPI"] = "commercialapi";
  PartnerType["PumpPartner"] = "pumppartner";
  return PartnerType;
}(PartnerType || {});
export default PartnerType;